import PaintUpsellingWorkspace from '../../placeholders/PaintUpsellingWorkspace';

export default PaintUpsellingWorkspace;
